import React from 'react';
import { Link } from 'react-router-dom';

const CGU: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-gray-100 px-6 py-4">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Aglomera" className="w-8 h-8 rounded-xl object-contain" style={{ background: '#e6edfa', padding: '4px' }} />
            <span className="font-bold text-lg" style={{ color: '#2a52a8' }}>Aglomera</span>
          </div>
          <Link to="/login" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">← Retour</Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Conditions Générales d'Utilisation</h1>
        <p className="text-sm text-gray-400 mb-10">Dernière mise à jour : 5 mai 2025</p>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>Article 1 — Présentation du service</h2>
          <p className="text-gray-700 leading-relaxed">
            Aglomera (ci-après « le Service ») est une plateforme web permettant aux candidats en recherche d'emploi d'agréger automatiquement les offres publiées sur les principaux sites de recrutement français, de créer des alertes personnalisées, et de recevoir des newsletters thématiques adaptées à leur profil. Le Service est édité et exploité par Gabriel Campant. Aglomera n'est pas affilié aux plateformes de recrutement tierces qu'il agrège.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>Article 2 — Acceptation des CGU</h2>
          <p className="text-gray-700 leading-relaxed">
            L'utilisation du Service implique l'acceptation pleine et entière des présentes Conditions Générales d'Utilisation. Si vous n'acceptez pas ces conditions, vous devez cesser d'utiliser le Service immédiatement. L'utilisation continue du Service après toute modification des CGU vaut acceptation des nouvelles conditions.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>Article 3 — Plans d'abonnement</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            Aglomera propose plusieurs formules d'abonnement :
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 pl-2">
            <li><strong>Gratuit</strong> : accès limité à 1 newsletter thématique, alerte 2 fois par semaine, sélection réduite d'offres.</li>
            <li><strong>Pro</strong> : accès à toutes les offres disponibles, envoi quotidien, tri IA selon votre profil.</li>
            <li><strong>Premium</strong> : toutes les fonctionnalités Pro + 3 newsletters thématiques simultanées + support prioritaire.</li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-3">
            Les paiements sont traités par Stripe. Aucune période d'essai n'est proposée. Les abonnements sont sans engagement et résiliables à tout moment. Aglomera se réserve le droit de modifier les tarifs avec notification préalable aux abonnés.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>Article 4 — Propriété intellectuelle et interdiction de reproduction</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            L'ensemble des contenus produits par Aglomera — incluant sans s'y limiter les newsletters thématiques, les sélections d'offres, les textes éditoriaux, les algorithmes de tri, l'interface graphique, la charte visuelle et le code source — constitue des œuvres protégées par le droit d'auteur et la propriété intellectuelle.
          </p>
          <p className="text-gray-700 leading-relaxed mb-3">
            <strong>Il est formellement interdit</strong> de reproduire, copier, diffuser, republier, transmettre, vendre, louer, concéder sous licence ou exploiter de quelque manière que ce soit tout ou partie du contenu des newsletters Aglomera ou de tout autre contenu produit par le Service, sans autorisation écrite préalable de Gabriel Campant.
          </p>
          <p className="text-gray-700 leading-relaxed">
            Toute violation de ces droits de propriété intellectuelle pourra faire l'objet de poursuites judiciaires civiles et/ou pénales, conformément aux dispositions du Code de la propriété intellectuelle français et des conventions internationales applicables.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>Article 5 — Compte utilisateur</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            L'accès au Service nécessite la création d'un compte personnel. L'utilisateur est seul responsable de la confidentialité de ses identifiants et de toutes les actions effectuées depuis son compte. Toute utilisation frauduleuse doit être signalée immédiatement à <a href="mailto:contact@aglomera.com" className="hover:underline" style={{ color: '#2a52a8' }}>contact@aglomera.com</a>.
          </p>
          <p className="text-gray-700 leading-relaxed">
            Aglomera se réserve le droit de suspendre ou supprimer tout compte en cas de violation des présentes CGU, sans préavis ni indemnité.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>Article 6 — Utilisation équitable et anti-abus</h2>
          <p className="text-gray-700 leading-relaxed mb-3">Afin de garantir un accès équitable au Service, les comportements suivants sont strictement interdits :</p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 pl-2">
            <li>Création de comptes multiples pour contourner les limitations du plan gratuit</li>
            <li>Utilisation automatisée ou par bot du Service sans autorisation</li>
            <li>Revente, redistribution ou exploitation commerciale des contenus Aglomera</li>
            <li>Toute tentative d'accès non autorisé aux systèmes d'Aglomera</li>
            <li>Utilisation du Service à des fins illégales ou contraires aux bonnes mœurs</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>Article 7 — Données personnelles</h2>
          <p className="text-gray-700 leading-relaxed">
            Le traitement des données personnelles des utilisateurs est décrit dans la{' '}
            <Link to="/confidentialite" className="hover:underline" style={{ color: '#2a52a8' }}>Politique de confidentialité</Link>.
            L'utilisateur consent à ce traitement en utilisant le Service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>Article 8 — Services tiers</h2>
          <p className="text-gray-700 leading-relaxed">
            Le Service recourt à des prestataires tiers : Google Firebase (authentification), Hetzner (hébergement), ForwardEmail (envoi des newsletters), Stripe (paiements). Aglomera n'est pas responsable du fonctionnement, des interruptions ou des pratiques de ces services tiers.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>Article 9 — Disponibilité du service</h2>
          <p className="text-gray-700 leading-relaxed">
            Aglomera s'efforce d'assurer la disponibilité du Service 24h/24 et 7j/7, mais ne peut garantir une continuité sans interruption. Des arrêts pour maintenance ou en cas de force majeure peuvent survenir sans préavis. Aglomera ne saurait être tenu responsable de dommages résultant d'une indisponibilité du Service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>Article 10 — Limitation de responsabilité</h2>
          <p className="text-gray-700 leading-relaxed">
            Aglomera agrège des offres d'emploi publiées par des tiers. Il ne garantit pas l'exactitude, la complétude ni l'actualité de ces offres. Aglomera ne saurait être tenu responsable des décisions prises par l'utilisateur sur la base des contenus fournis, ni de tout dommage indirect résultant de l'utilisation ou de l'impossibilité d'utiliser le Service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>Article 11 — Résiliation</h2>
          <p className="text-gray-700 leading-relaxed">
            L'utilisateur peut supprimer son compte à tout moment directement depuis la page <strong>Mon profil</strong> de l'application. Il peut également résilier son abonnement ou contacter le support à <a href="mailto:contact@aglomera.com" className="hover:underline" style={{ color: '#2a52a8' }}>contact@aglomera.com</a>. La résiliation prend effet à la fin de la période d'abonnement en cours. Aucun remboursement partiel ne sera effectué.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>Article 12 — Droit applicable</h2>
          <p className="text-gray-700 leading-relaxed">
            Les présentes CGU sont régies par le droit français. Tout litige relatif à leur interprétation ou à leur exécution sera soumis, après tentative de résolution amiable, à la compétence exclusive des tribunaux français compétents.
          </p>
        </section>

        <div className="mt-12 pt-8 border-t border-gray-100 text-center text-sm text-gray-400">
          Pour toute question : <a href="mailto:contact@aglomera.com" className="hover:underline" style={{ color: '#2a52a8' }}>contact@aglomera.com</a>
        </div>
      </main>
    </div>
  );
};

export default CGU;
